import { Mark, mergeAttributes } from '@tiptap/core';

export const LETTER_TEMPLATE_FONT_SIZES = Object.freeze([8, 9, 10, 11, 12, 14, 16, 18, 20, 24]);

export const LETTER_TEMPLATE_DEFAULT_FONT_SIZE_PT = 11;

export const LETTER_TEMPLATE_HEADING_FONT_SIZES_PT = Object.freeze({
  1: 20,
  2: 16,
  3: 14,
});

export const LetterFontSizeExtension = Mark.create({
  name: 'letterFontSize',
  inclusive: true,

  addAttributes() {
    return {
      pt: {
        default: LETTER_TEMPLATE_DEFAULT_FONT_SIZE_PT,
        parseHTML: (element) => {
          const raw = element.getAttribute('data-letter-font-size');
          const pt = Number(raw);
          return LETTER_TEMPLATE_FONT_SIZES.includes(pt)
            ? pt
            : LETTER_TEMPLATE_DEFAULT_FONT_SIZE_PT;
        },
        renderHTML: (attributes) => ({
          'data-letter-font-size': attributes.pt,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-letter-font-size]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const pt = Number(HTMLAttributes['data-letter-font-size']) || LETTER_TEMPLATE_DEFAULT_FONT_SIZE_PT;
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        style: `font-size: ${pt}pt`,
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setLetterFontSize:
        (pt) =>
        ({ chain }) => {
          const size = Number(pt);
          if (!LETTER_TEMPLATE_FONT_SIZES.includes(size)) return false;
          if (size === LETTER_TEMPLATE_DEFAULT_FONT_SIZE_PT) {
            return chain().focus().unsetMark(this.name).run();
          }
          return chain().focus().setMark(this.name, { pt: size }).run();
        },
      unsetLetterFontSize:
        () =>
        ({ chain }) =>
          chain().focus().unsetMark(this.name).run(),
    };
  },
});

export default LetterFontSizeExtension;
